// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


const requiredPart = t.interface({
  code: t.string,
  id: t.Integer,
});

export const ColumnHeaderSchema = excess(requiredPart);

export interface ColumnHeader extends t.TypeOf<typeof ColumnHeaderSchema> {}
